import { ArrowLeft, LayoutGrid, ListChecks, ShieldCheck } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import FormBuilder from '../../components/FormBuilder';
import { apiRequest } from '../../services/api';

// Mevcut bir formu düzenlemek için tam sayfa editör
export default function FormEditPage({ updateForm }) {
  const { id } = useParams();
  const navigate = useNavigate();
  // Form detayı liste endpoint'inde değil; düzenleme için tam detayı ayrı endpoint'ten çekiyoruz
  // (liste yanıtı görsel seçim base64'lerini içermez, hızlı kalır)
  const [form, setForm] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    async function loadForm() {
      try {
        setLoading(true);
        setError(null);
        const data = await apiRequest(`/api/forms/admin/${id}`);
        if (!cancelled) {
          setForm(data);
        }
      } catch (exception) {
        if (!cancelled) {
          setError(exception.message || 'Form yüklenemedi.');
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    }
    loadForm();
    return () => { cancelled = true; };
  }, [id]);

  async function saveEdit(payload) {
    const saved = await updateForm(id, payload);
    if (saved) {
      navigate('/admin/formlar');
    }
  }

  if (loading) {
    return (
      <section className="form-create-page">
        <div className="form-create-hero">
          <div className="form-create-hero-content">
            <p className="muted">Form yükleniyor...</p>
          </div>
        </div>
      </section>
    );
  }

  if (error || !form) {
    return (
      <section className="form-create-page">
        <div className="form-create-hero">
          <div className="form-create-hero-content">
            <p className="muted">{error || 'Form bulunamadı.'}</p>
            <button className="btn btn-light" style={{ marginTop: 12 }} onClick={() => navigate('/admin/formlar')}>
              <ArrowLeft size={15} /> Listeye dön
            </button>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="form-create-page">
      {/* Sayfa başlığı */}
      <header className="form-create-hero">
        <div className="form-create-hero-content">
          <span className="form-create-eyebrow">
            <LayoutGrid size={14} /> Form Düzenleme
          </span>
          <h1>{form.name}</h1>
          <p>
            Bölüm ve alanları güncelleyin, yeni alanlar ekleyin veya mevcut alanları kaldırın.
            Kaydettiğiniz değişiklikler bu formu dolduran tüm kullanıcıların ekranına yansır.
          </p>
        </div>
        <div className="form-create-hero-glow" aria-hidden="true" />
      </header>

      {/* İpucu kartları */}
      <div className="form-create-tips">
        <article className="form-create-tip">
          <span className="form-create-tip-icon"><LayoutGrid size={18} /></span>
          <div>
            <h4>Alanlar anında güncellenir</h4>
            <p>Kaydettiğiniz andan itibaren atanmış kullanıcılar güncel formu görür.</p>
          </div>
        </article>
        <article className="form-create-tip">
          <span className="form-create-tip-icon"><ListChecks size={18} /></span>
          <div>
            <h4>Doldurulmuş alanlar korunur</h4>
            <p>Daha önce gönderim yapılmış alanlar sistemden kaldırılamaz.</p>
          </div>
        </article>
        <article className="form-create-tip">
          <span className="form-create-tip-icon"><ShieldCheck size={18} /></span>
          <div>
            <h4>Geri dönmek için oku kullanın</h4>
            <p>Kaydedilmemiş değişiklikler form listesine döndüğünüzde kaybolur.</p>
          </div>
        </article>
      </div>

      {/* Form yapılandırıcı */}
      <div className="form-create-builder">
        <div className="form-create-builder-header">
          <div>
            <h2>Form Yapılandırıcı</h2>
            <p className="muted">Bölümleri ve alanları düzenleyin.</p>
          </div>
          <button className="btn btn-light" onClick={() => navigate('/admin/formlar')}>
            <ArrowLeft size={15} /> Listeye dön
          </button>
        </div>
        <div className="form-create-builder-body">
          <FormBuilder initialForm={form} onSave={saveEdit} submitLabel="Değişiklikleri kaydet" />
        </div>
      </div>
    </section>
  );
}
